function initHeroSlider() {
	if (typeof Swiper === "undefined") {
		return;
	}

	const el = document.querySelector('[data-swiper="hero"]');
	if (!el) {
		return;
	}

	new Swiper(el, {
		loop: true,
		effect: "fade",
		fadeEffect: { crossFade: true },
		autoplay: {
			delay: 6000,
			disableOnInteraction: false,
		},
		pagination: {
			el: el.querySelector(".swiper-pagination"),
			clickable: true,
		},
	});
}

function initProductSliders() {
	if (typeof Swiper === "undefined") {
		return;
	}

	document.querySelectorAll('[data-swiper="products"]').forEach((trackEl) => {
		const root = trackEl.closest(".product-slider");

		new Swiper(trackEl, {
			effect: "slide",
			rewind: true,
			slidesPerView: 1,
			spaceBetween: 16,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: root.querySelector("[data-slider-next]"),
				prevEl: root.querySelector("[data-slider-prev]"),
			},
			breakpoints: {
				580: { slidesPerView: 2, spaceBetween: 20 },
				1024: { slidesPerView: 3, spaceBetween: 80 },
			},
		});
	});
}

function initClientSliders() {
	if (typeof Swiper === "undefined") {
		return;
	}

	document.querySelectorAll('[data-swiper="clients"]').forEach((trackEl) => {
		const root = trackEl.closest(".client-slider");

		new Swiper(trackEl, {
			slidesPerView: 1,
			spaceBetween: 24,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: root.querySelector("[data-slider-next]"),
				prevEl: root.querySelector("[data-slider-prev]"),
			},
			breakpoints: {
				480: { slidesPerView: 2 },
				680: { slidesPerView: 3 },
				980: { slidesPerView: 4 },
				1280: { slidesPerView: 5, spaceBetween: 80 },
			},
		});
	});
}

function initProductGalleries() {
	if (typeof Swiper === "undefined") {
		return;
	}

	document.querySelectorAll('[data-swiper="gallery-thumbs"]').forEach((thumbsEl) => {
		const mainEl = document.querySelector(`[data-swiper="gallery-main"][data-gallery-for="#${thumbsEl.id}"]`);
		const galleryEl = thumbsEl.closest(".product-gallery");
		if (!mainEl) {
			return;
		}

		const thumbsSwiper = new Swiper(thumbsEl, {
			slidesPerView: 3,
			spaceBetween: 16,
			watchSlidesProgress: true,
			watchOverflow: true,
			navigation: {
				nextEl: galleryEl?.querySelector("[data-gallery-thumbs-next]"),
				prevEl: galleryEl?.querySelector("[data-gallery-thumbs-prev]"),
			},
		});

		new Swiper(mainEl, {
			slidesPerView: 1,
			spaceBetween: 0,
			thumbs: {
				swiper: thumbsSwiper,
				autoScrollOffset: 1,
			},
		});
	});
}

initHeroSlider();
initProductSliders();
initClientSliders();
initProductGalleries();

